<template lang="pug">
#PageResultPossibleLocation
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Possible Location" :HeaderGlobalBreadcrumb="breadcrumb")

    ResultFilter

    //- box recent location
    .box
        header.flex.items-center.justify-between.box__header.no-border
            .header-meta
                h2.subheading Possible Location
            .header-cta

        .box__body
            .box-tabs
                vue-tabs
                    v-tab(title="Office")
                        PossibleLocationOffice

                    v-tab(title="Home")
                        PossibleLocationHome

                    v-tab(title="Top Location")
                        PossibleLocationTop


</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import ResultFilter from './../result/ResultFilter.vue'
import {VueTabs, VTab} from 'vue-nav-tabs'

import PossibleLocationOffice from './../../pages/result/possible/Office.vue'
import PossibleLocationHome from './../../pages/result/possible/Home.vue'
import PossibleLocationTop from './../../pages/result/possible/TopLocation.vue'

export default {
    name: 'PossibleLocation',
    components: {
        HeaderGlobal,
        ResultFilter,
        VueTabs,
        VTab,
        PossibleLocationOffice,
        PossibleLocationHome,
        PossibleLocationTop,
    },
    props: ['resultGlobalBreadcrumb'],
    data: function () {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Possible Location',
                    url: '/result/possible-location',
                },
            ],
        };
    },

    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        }
    }
}
</script>

<style lang="sass">
</style>
